import React, { Component } from "react";

function App(props) {
  return (
    <div className="row pago-servicio-titulo">
      <div className="col-md-2">
        <img className="pago-servicio-img-2" src={props.img} height="80px"/>
      </div>
      <div className="col-md-6" style={{paddingTop: 20,fontSize: 15}}>
        {props.empresa}
      </div>
    </div>
  ) 
}
 
export default App;